
import { useState } from "react";
import { Col, Container, Row, Dropdown, Navbar, Offcanvas } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ssoLogOut } from "../../Services/auth";
import Logo from "../../Asset/Img/logo.svg";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux"
import "./index.css"
import "./index.css";
import { setAuth } from "../../Redux/Slice/authSlice"


const Header = () => {
    const dispatch = useDispatch();
    let navigate = useNavigate();

    let handleLogout = async () => {
        let res = await ssoLogOut(localStorage?.access_token)
        if (res && res.status == '200') {
            localStorage.clear()
            dispatch(setAuth({ isAuthenticated: false, token: '', loginType: '' }))
            navigate('/login')
        }
    }

    let getInitials = () => {
        const firstName = localStorage?.firstName?.charAt(0) || "";
        const surname = localStorage?.lastName?.charAt(0) || "";
        if (firstName.length > 0 && surname.length > 0) {
            return firstName[0] + surname[0];
        } else if (firstName.length > 0 && surname.length <= 0) {
            return firstName[0];
        } else {
            return "";
        }
    }

    return (
        <header className="header-layout">
            <Navbar expand="lg" className="bg-transparent">
                <Container fluid className="justify-content-start">
                    <div className="main-logo-brand">
                        <Navbar.Brand href="#home" className="d-inline-block">
                            <div className="logo">
                                <span className="logo-brand"><img src={Logo} alt="logo" /></span>
                            </div>
                        </Navbar.Brand>
                    </div>
                    <Navbar.Offcanvas
                        id="offcanvasNavbar-expand-lg"
                        aria-labelledby="offcanvasNavbarLabel-expand"
                        placement="start"
                        className="offside-canvas-bg"
                    >
                        <Offcanvas.Header closeButton className="border-bottom">
                            <div className="profile-flx-wgts">
                                <div className="name-short-txtw"><span className="symt-txt-wap">{getInitials()}</span></div>
                                <h3 className="title-nm-log">{localStorage.userName? localStorage.userName : ''}</h3>
                            </div>
                        </Offcanvas.Header>
                        <Offcanvas.Body className="justify-content-lg-end p-0">
                            <div className="manage-profile-flx">
                                <div className="text-lg-end p-3 p-lg-0">
                                    <ul className="hmt-menu mb-0">
                                        {/* <li onClick={() => navigate('/pricebook')} className={`menu-itms-nv ${window.location.pathname.includes('pricebook') ? 'active' : ''}`}><Link to="/">PriceBook</Link></li>
                                        <li onClick={() => navigate('/dashboard')} className={`menu-itms-nv ms-3 ${window.location.pathname.includes('dashboard') ? 'active' : ''}`}><Link to="dashboard">Dashboard</Link></li> */}
                                        <li onClick={() => navigate('/home')} className="menu-itms-nv ms-xl-3">
                                            <Link  >Home</Link>
                                        </li>
                                        <li onClick={() => navigate('/dashboard')} className="menu-itms-nv ms-xl-3">
                                            <Link >Dashboard</Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="flx-signwds d-lg-none">
                                    <button  onClick={() => handleLogout()}  type="button" className="btn btn-signout-side border-0"><i class="fas fa-sign-out-alt me-1"></i> Sign Out</button>
                                </div>
                            </div>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                    <div className="user-profile-side ms-lg-3">
                        <Dropdown>
                            <Dropdown.Toggle variant="" className="btn-nm-profile" id="profile-user-id"><span className="user-txt-circle">{getInitials()}</span></Dropdown.Toggle>
                            <Dropdown.Menu className="dropdow-menu-profile" align="end">
                                <div className="middle-usr-flx">
                                    <div className="top-us-pts d-flex justify-content-between">
                                        <div className="left-sd--wtm"><span className="txt-small-su">S3S</span></div>
                                        <div onClick={() => handleLogout()} style={{ cursor: 'pointer' }} className="right-sd--wtm"><span className="txt-small-su">Sign Out</span></div>
                                    </div>
                                    <div className="d-flex flex-wrap mng-user-flx align-items-center">
                                        <div className="user-icon-web">
                                            <span className="user-nm-short">{getInitials()}</span>
                                        </div>
                                        <div className="user-info-pfl">
                                            <div className="inf-flxcard-wt">
                                                <h4 className="fl-name-txt">{localStorage?.userName}</h4>
                                                <span className="type-user-txt">{localStorage.email}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    <Navbar.Toggle aria-controls="offcanvasNavbar-expand-lg" className="border-0 toggle-sidemenu-btn outline-0 shadow-none p-0 ms-3" />
                </Container>
            </Navbar>
            <Container fluid>
                <Row className="align-items-center">
                    <Col xs={6} md={3}>

                    </Col>
                    <Col xs={6} md={9}>

                    </Col>
                </Row>
            </Container>
        </header>

    )
}
export default Header;